import React, { useEffect, useState } from "react";
import BASE_URL from "../../config";

export default function Join() {

  const [contact, setContact] = useState(null);

  const [form, setForm] = useState({
    name: "",
    phone: "",
    address: ""
  });

  // 🔄 Fetch contact
  useEffect(() => {
    const fetchContact = () => {
      fetch(`${BASE_URL}/api/getContact.php?t=${Date.now()}`)
        .then(res => res.json())
        .then(data => setContact(data));
    };

    fetchContact();
    const interval = setInterval(fetchContact, 3000);
    return () => clearInterval(interval);
  }, []);

  // ✏️ Handle input
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  // 🚀 Submit form
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", form.name);
    formData.append("phone", form.phone);
    formData.append("address", form.address);

   fetch(`${BASE_URL}/api/saveJoin.php`, {
      method: "POST",
      body: formData
    })
      .then(res => res.text())
      .then(msg => {
        alert(msg);

        // clear form
        setForm({
          name: "",
          phone: "",
          address: ""
        });
      })
      .catch(err => console.error(err));
  };

  const whatsappNumber = contact?.phone1 || "917203030236";

  const openWhatsApp = () => {
    const message = `Hello, I want to apply.\nName: ${form.name}\nPhone: ${form.phone}`;
    window.open(
      `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <div className="join-page">

      <div className="join-container">

        {/* LEFT SIDE */}
        <div className="join-left">

          <div className="join-info">
            <h3>અમારું ઓફિસ સરનામું</h3>

            <p>{contact?.address || "Loading..."}</p>

            <p>
              {contact
                ? `${contact.phone1} / ${contact.phone2}`
                : "Loading..."}
            </p>

            <h3>કામકાજ નો સમય</h3>
            <p>{contact?.timing || "Loading..."}</p>

             <h6>ઈમેલ આઈડી</h6>
            <p>shreedhanlaxmimahila123@gmail.com</p>

          </div>

          {/* <div className="map-container">
            <iframe
              src="https://www.google.com/maps?q=Katargam+Surat&output=embed"
              width="100%"
              height="200"
              style={{ border: 0 }}
              loading="lazy"
              title="map"
            ></iframe>
          </div> */}

<div className="map-container">

<a
href="https://www.google.com/maps/dir/?api=1&destination=MatruChhaya+Bungalows+Katargam+Surat"
target="_blank"
rel="noopener noreferrer"
>

<iframe
src="https://www.google.com/maps?q=MatruChhaya+Bungalows+Katargam+Surat&output=embed"
width="100%"
height="200"
style={{ border: 0 }}
loading="lazy"
title="map"
></iframe>

</a>

</div>
<a
href="https://www.google.com/maps/dir/?api=1&destination=MatruChhaya+Bungalows+Katargam+Surat"
target="_blank"
className="direction-btn"
>
દિશા મેળવો
</a>

        </div>

        {/* RIGHT SIDE */}
        <div className="join-right">

          <form className="join-form" onSubmit={handleSubmit}>

            <div className="form-group">
              <label>પૂરું નામ</label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="તમારું નામ દાખલ કરો"
                required
              />
            </div>

            <div className="form-group">
              <label>મોબાઇલ નંબર</label>
              <input
                type="text"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="મોબાઇલ નંબર"
                required
              />
            </div>

            <div className="form-group">
              <label>પ્રશ્ન</label>
              <textarea
                name="address"
                value={form.address}
                onChange={handleChange}
                placeholder="તમારો પ્રશ્ન"
                required
              ></textarea>
            </div>

            <button type="submit">અરજી કરો</button>

            {/* WhatsApp */}
            <div className="whatsapp-contact" onClick={openWhatsApp}>
              <img
                src="https://cdn-icons-png.flaticon.com/512/220/220236.png"
                alt="WhatsApp"
              />
              <span>વોટ્સએપ પર ચેટ કરો</span>
            </div>

          </form>

        </div>

      </div>
    </div>
  );
}